import qs from 'query-string';

function report(bizType, pageType, pageValue, data) {
  const url = '//m.meitun.com/h5/monitor/performance.gif';
  const paramsObj = Object.assign({}, data, {
    bt: bizType,
    pt: pageType,
    pv: pageValue,
    biztype: bizType
  });
  const params = qs.stringify(paramsObj);
  const img = new Image(1, 1);
  img.src = `${url}?${params}`;
}

function getTimingObj(performance, now) {
  const timing = performance.timing;
  const navigation = performance.navigation;
  const markArr = performance.getEntriesByName('router');
  const markCount = markArr.length;
  let newStartTime;
  let time;
  let isSPR = false;
  if (markCount > 0) {
    newStartTime = markArr[markCount - 1].startTime;
    isSPR = true;
  }
  const timingData = {
    RDTT: isSPR ? 0 : navigation.redirectCount,
    RDTM: isSPR ? 0 : timing.redirectEnd - timing.redirectStart,
    DMLKT: isSPR ? 0 : timing.domainLookupEnd - timing.domainLookupStart,
    CONTT: isSPR ? 0 : timing.connectEnd - timing.connectStart,
    REQT: isSPR ? 0 : timing.responseStart - timing.requestStart,
    RSPT: isSPR ? 0 : timing.responseEnd - timing.responseStart,
    DMPT: isSPR ? 0 : timing.domInteractive - timing.domLoading,
    DMLT: isSPR ? 0 : timing.domComplete - timing.domInteractive,
    ONLOADT: isSPR ? 0 : timing.loadEventEnd - timing.loadEventStart,
    PAGET: isSPR ? 0 : timing.domComplete - timing.fetchStart,
    ALLT: isSPR ? 0 : timing.domComplete - timing.navigationStart,
    BEFDMLT: isSPR ? 0 : timing.domLoading - timing.navigationStart,
    RESLOADT: isSPR ? 0 : timing.loadEventStart - timing.domLoading,
    SCRIPTT: isSPR ? 0 : timing.loadEventStart - timing.domContentLoadedEventStart,
    // CINTT: isSPR ? cinitTiming : cinitTiming - timing.navigationStart,
    INTT: timing.domContentLoadedEventStart - timing.navigationStart
  };
  if (newStartTime) {
    time = now - newStartTime;
  }
  if (isSPR) {
    timingData.INTT = time;
  }
  if (time) {
    timingData.CINTT = isSPR ? time : time - timing.navigationStart;
  }
  timingData.FST = timingData.CINTT;
  return timingData;
}

const getTiming = () => {
  return new Promise((resolve, reject) => {
    const performance = window.performance || window.webkitPerformance || window.msPerformance || window.mozPerformance;
    if (typeof performance === 'undefined') {
      reject();
      return;
    }
    if (!performance.getEntriesByName || !performance.mark) {
      reject();
      return;
    }
    const now = performance.now();
    if (performance.timing.loadEventEnd) {
      const timingData = getTimingObj(performance, now);
      resolve(timingData);
      console.log('1:', timingData);
      return;
    }
    window.addEventListener('load', function onLoad() {
      window.removeEventListener('load', onLoad, false);
      if (requestAnimationFrame) {
        requestAnimationFrame(() => {
          const timingData = getTimingObj(performance, now);
          resolve(timingData);
          console.log('2:', timingData);
        });
      } else {
        setTimeout(() => {
          const timingData = getTimingObj(performance, now);
          resolve(timingData);
          console.log('2:', timingData);
        });
      }
    }, false);
  });
};
/**
 * @param biztype 2 大健康
 * @param pageType 1  开讲用户端  2 开讲专家端
 * @param pageValue String 页面title
 * @param isSPR Boolean
 */
export default function ({ bizType = 2, pageType = 1, pageValue = document.title }) {
  return getTiming().then((data) => {
    report(bizType, pageType, pageValue, data);
  }).catch((e) => {
    console.log(e);
  });
}




// WEBPACK FOOTER //
// ./src/comm/utils/reportTiming.js